import { connectCustom } from "@client/lib/misc";
import { TargetSelector, activePopupSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState, type WithClassName } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import { type EntityContainerProps } from "@client/viewer/layout/Entity/Container/container";
import Component, { type PopupContainerProps } from "./component";

const STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  position: "relative",
  height: "100%",
  width: "100%",
  minWidth: 0
};
export type PopupContainerContainerProps = Partial<WithClassName> &
  WithChildren & {
    canClose?: boolean;
    EntityContainer?: React.ComponentType<EntityContainerProps>;
    keepOpenOnOverlayClick?: boolean;
    popupClassName?: string;
    topMenu?: any;
  };
const makeMapStateToProps = () => {
  const activePopupSettingsSelector = combinedSettingsSelector<{
    behaviour: "over" | "push";
    pushPosition: "bottom" | "top";
  }>(TargetSelector.Entity, ["behaviour", "pushPosition"]);

  return (state: AppState, props: PopupContainerContainerProps): PopupContainerProps => {
    const activePopup = activePopupSelector(state);
    const pp = activePopup ? activePopupSettingsSelector(state, { id: activePopup.entityId, source: "popup" }) : null;

    return {
      ...props,
      ...pp,
      activePopupId: activePopup?.entityId,
      canClose: props.canClose ?? activePopup?.state !== "openFixed",
      children: props.children,
      isEditMode: state.isEditMode,
      style: STYLE
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
